import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MotionConfig } from 'motion/react';
import '@fontsource-variable/bricolage-grotesque';
import '@fontsource/atkinson-hyperlegible-next/400.css';
import '@fontsource/atkinson-hyperlegible-next/600.css';
import '@fontsource/atkinson-hyperlegible-next/700.css';
import './styles/app.css';
import { App } from './App.tsx';
import { SessionProvider } from './lib/session.tsx';
import { ToastProvider } from './components/ui.tsx';
import { ApiError } from './lib/api.ts';
import { registerServiceWorker } from './lib/install.ts';
import { applyCachedTheme } from './lib/theme.ts';

// The colours chosen last time on this device, before anything renders.
applyCachedTheme();
registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 5_000,
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Animations follow the operating system's "reduce motion" setting. */}
      <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <SessionProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </SessionProvider>
      </BrowserRouter>
      </MotionConfig>
    </QueryClientProvider>
  </StrictMode>,
);
